import { ArticleModel } from "../archive/article.model";

export class ProviderInvoiceDetailModel {
  providerInvoiceDetailId: number = 0;
  providerInvoiceId: number = 0;
  articleId: number = 0;
  article: ArticleModel | null = null;
  conceptInvoicingId: number | null = null;
  inventoryEntryDetailId: number | null = null;
  purchaseOrderDetailId: number | null = null;
  quantity: number = 0;
  unitValue: number = 0;
  discountRate: number = 0;
  taxId: number = 0;
  ivaRate: number = 0;
  ivaBase: number = 0;
  retainedValue: number = 0;
  createDate: Date | null = null;
  userNameCreate: string | null = null;
  updateDate: Date | null = null;
  userNameUpdate: string | null = null;
  //Solo se usa en el from
  articleCode: string = '';
  articleName: string = '';
  getRegister: boolean = false;
}
